var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"w-100 text-center"},[_c('h3',[_vm._v(" Carregando... ")]),_c('img',{attrs:{"src":"https://mir-s3-cdn-cf.behance.net/project_modules/max_632/3f3a3831234507.564a1d2338123.gif"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }